<template lang="pug">
.app-only-card-container(v-if="cards.length")
  template(v-if="cards.length")
    .card-item(v-for="item in cards")
      app-card-coupons-item(:info="item", @btn="clickBtn(item)")
  template(v-else)
    Empty
  .more.flex-mid(@click="goLink")
    span 查看更多特惠卡券
    .common-arrow-right
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import config from '@/const/config';
import { getAppGoods } from '@/api/fuli';
import Empty from '@/components/empty';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getTokenAndLocation } from '../../../utils';
import AppCardCouponsItem from './app-card-coupon-item';
import { CARD_COUPON_TYPE } from '../consts';
import { welfareGo } from '../utils';

const goodsMapper = (item) => {
  const {
    goodsName: title,
    listPicUrl,
    salePrice,
    originalPrice,
    skuId,
    spuId,
    goodsEquitys,
  } = item;
  UBT.moduleExpose({
    pageId: 'Welfare',
    categoryId: 'platform',
    moduleId: 'welfare_mall',
    contentId: 'welfare_mall',
    exposureTimes: 1,
    businessInfo: {
      coupon_name: title,
    },
  });
  return {
    type: CARD_COUPON_TYPE.COUPON,
    title,
    pic: listPicUrl,
    currentPrice: salePrice,
    originPrice: originalPrice,
    skuId,
    spuId,
    assets: goodsEquitys
      ? `${goodsEquitys.map((v) => v.virtualName).join('、')}等`
      : '',
  };
};

export default {
  components: {
    AppCardCouponsItem,
    Empty,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cards: [],
      env,
      businessType: '0',
    };
  },
  computed: {
    platform() {
      if (env.isWechatMini) {
        return '2';
      }
      if (this.isH5) {
        return '3';
      }
      if (env.isAliMP || env.isAliMPMonitor) {
        return '1';
      }
      if (env.isEasyBikeApp) {
        if (env.isAndroid) {
          return '0';
        }
        if (env.isIOS) {
          return '10';
        }
      }
      return '3';
    },
  },
  methods: {
    goLink() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'mall_more',
        categoryId: 'platform',
        businessInfo: {},
      });
      welfareGo(
        this.link
          || `https://m.hellobike.com/AppPlatformH5/${
            config.env !== 'pro' ? `${config.env}/` : ''
          }latest/pr_index_card-for-app.html#/card-for-app?adsource=flzx`,
      );
    },
    clickBtn(item) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'welfare_mall',
        categoryId: 'platform',
        businessInfo: {
          coupon_name: item.title,
        },
      });
      const link = `https://m.hellobike.com/AppBikeMallH5/${
        config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/TicketDetail?from=0&hiddenNavBar=1&spuId=${
        item.spuId
      }`;
      welfareGo(link);
    },
    async getData() {
      const { token, adCode, cityCode } = await getTokenAndLocation();
      this.link = `https://m.hellobike.com/AppBikeMallH5/${
        config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html?from=0&hiddenNavBar=1`;
      const data = await getAppGoods({
        token,
        adCode,
        cityCode,
        systemCode: 62,
        pageSize: 3,
        pageNum: 1,
        categoryId: 0,
      })
        .then((v) => v.data || [])
        .catch(() => []);

      if (!data.length) {
        this.$emit('showModule', false);
        return Promise.resolve();
      }

      this.cards = data.map(goodsMapper);
      if (!this.cards || this.cards.length === 0) {
        this.$emit('tab', false);
      }
      return Promise.resolve();
    },
  },
};
</script>

<style lang="less" scoped>
.app-only-card-container {
  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.16rem;

    * {
      border-color: #999 !important;
    }
  }

  .card-item {
    margin-bottom: 0.12rem;
  }
}
</style>
